import { useStyles } from './description-block.style'
import { PlainTextBlock } from '../plaintext/plaintext-block'
import { REPORT_VIEWERS } from '../../constants'

export const DescriptionBlock = function ({ report = {} }) {
  const classes = useStyles({ variant: report.viewer === REPORT_VIEWERS.EXECUTIVE_SUMMARY_PAGE ? 'executiveSummary' : 'page' })

  return <PlainTextBlock className={classes.description} as="p" name="description" report={report} placeholder="Enter an optional description for this page" />
}
